"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _icon = _interopRequireDefault(require("./../../../fonts/icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LinkItem = props => {
  const {
    exact,
    link,
    onLinkActive
  } = props;
  const idString = link.title.split(' ')[0];
  const handleRouteMatch = (match, location) => {
    if (onLinkActive) onLinkActive(match, link);
    return match;
  };
  if (!link) return false;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'position-relative'
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    activeClassName: 'active',
    className: 'menu-link-wrapper d-flex align-items-center no-underline',
    exact: exact,
    isActive: handleRouteMatch,
    to: link.path
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'd-flex justify-content-center align-content-center menu-item-wrapper'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'material-icons align-self-center d-flex',
    id: idString,
    "data-toggle": "tooltip",
    "data-placement": "right",
    title: link.title
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    icon: link.icon,
    size: 24
  }) || /*#__PURE__*/_react.default.createElement(_icon.default, {
    icon: "menu",
    size: 24
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'justify-content-center'
  }, link.title || link.path)));
};
var _default = exports.default = LinkItem;
module.exports = exports.default;